<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    cancelBtnText: {
      type: String,
      default: '',
    },
    confirmBtnText: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '530px',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    cancelHandle() {
      this.dialogVisible = false
      this.$emit('cancel')
    },
    beforeClose(done) {
      this.$emit('cancel')
      done()
    }
  }
}
</script>

<template>
  <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :append-to-body="appendToBody"
      :before-close="beforeClose"
      :width="width">
    <div class="mt-4 text-[14px] font-normal text-[#1F2D42 ]" v-if="!$slots.cus">
      <slot></slot>
    </div>
    <slot name="cus"></slot>
    <span slot="footer" class="dialog-footer">
        <slot name="thirdBtn"></slot>
        <el-button v-if="cancelBtnText" @click="cancelHandle" :autofocus="false" plain class="w-[80px] border-black text-black">{{cancelBtnText}}</el-button>
        <el-button v-if="confirmBtnText" type="success" class="w-[80px] p-0" @click="$emit('confirmSubmit')">{{confirmBtnText}}</el-button>
      </span>
  </el-dialog>
</template>

<style scoped lang="less">
/deep/ .el-button.is-plain:hover {
  border: 1px solid #000000;
  color: #FFFFFF;
  background: #000000;
}
/deep/ .el-button.is-plain:focus{
  border: 1px solid #000000;
  color: #000000;
  background: #FFFFFF;
}
</style>